import React from 'react';
import { ShopDonationBanner } from '../../../components/shop/ShopDonationBanner';
import { DONATION_LINK } from '../../../utilities/shop';

export const ShopDonationBannerContainer = () => {
    return <ShopDonationBanner onClick={() => window.open(DONATION_LINK, '_blank')} />
}